var map = {
	"./arrow-left.svg": 522,
	"./arrow.svg": 523,
	"./back.svg": 524,
	"./bookmark.svg": 525,
	"./close-2.svg": 526,
	"./close-3.svg": 527,
	"./close-4.svg": 528,
	"./close.svg": 529,
	"./down.svg": 445,
	"./dropdown.svg": 530,
	"./ecosystem.svg": 531,
	"./facebook.svg": 532,
	"./file-pdf.svg": 533,
	"./government.svg": 534,
	"./impersonalization.svg": 535,
	"./instagram.svg": 536,
	"./left.svg": 537,
	"./like.svg": 538,
	"./loading.svg": 539,
	"./lock.svg": 540,
	"./logout.svg": 541,
	"./mail.svg": 542,
	"./menu.svg": 543,
	"./moscow-en.svg": 544,
	"./moscow-ru.svg": 545,
	"./partnership.svg": 546,
	"./pencil.svg": 547,
	"./person-2.svg": 446,
	"./person.svg": 548,
	"./phone.svg": 549,
	"./pin.svg": 550,
	"./placemark.svg": 551,
	"./presentation.svg": 552,
	"./printer.svg": 553,
	"./question.svg": 554,
	"./reply.svg": 555,
	"./rocket.svg": 556,
	"./science.svg": 557,
	"./search.svg": 558,
	"./send.svg": 559,
	"./share.svg": 560,
	"./sk-en.svg": 561,
	"./sk-ru.svg": 562,
	"./sk-veb-en.svg": 563,
	"./sk-veb-ru.svg": 564,
	"./sk.svg": 565,
	"./smile.svg": 566,
	"./star-filled.svg": 567,
	"./star.svg": 568,
	"./talk.svg": 569,
	"./telegram.svg": 570,
	"./tick.svg": 429,
	"./twitter.svg": 571,
	"./undo.svg": 572,
	"./user.svg": 573,
	"./veb-rf-en.svg": 574,
	"./veb-rf-ru.svg": 575,
	"./video.svg": 576,
	"./vk.svg": 577,
	"./website.svg": 578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;